module.exports = "<h1>\n  {{title}}\n</h1>\n<h3>Inside app.component.html</h3>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 170
// module chunks = 1